import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { tracker } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { isBillingAdminSelector } from 'pricing-pages-ui/selectors/AuthSelectors';
import { isAppAuthSelector } from 'pricing-pages-ui/selectors/AuthSelectors';
import Loadable from 'UIComponents/decorators/Loadable';
import { isWordPress } from 'hubspot-plugin-common';
import { useQueryParamFromLocation } from 'pricing-pages-ui/utils/urls/queryParamUtils';
import { UPGRADE_SOURCE } from 'pricing-pages-lib/constants/QueryParams';
import { activeCurrencySelector } from 'pricing-pages-ui/selectors/CurrencySelectors';
import { getFullUrl } from 'hubspot-url-utils';
import { Metrics } from '../utils/metrics';
import { hasMisMatchedProductsAndPromotionsSelector } from '../selectors/ProductsSelectors';
import { useAppSelector } from '../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../selectors/LoadingStateSelectors';
import ErrorPage from '../components/error-page/ErrorPage';
import { MISMATCHED_RESPONSES } from '../constants/ErrorCauses';
const PublicApplicationComponents = Loadable({
  loader: () => import(
  /* webpackChunkName: "PublicApplicationComponents" */
  'pricing-pages-ui/containers/PublicApplicationComponents'),
  LoadingComponent: () => {
    return null;
  }
});

const isHubSpotDotComAuthedUserRedirect = () => {
  // Has to work for different TLDs, e.g. www.hubspot.jp
  const WWW_REFERRER_SUBSTRING = 'www.hubspot.';
  const BR_REFERRER_SUBSTRING = 'br.hubspot.'; // If you have multiple portals, you go from public pricing -> portal picker page -> in-app page. This is not perfect detection
  // as it will pick up ANY time you short link to pricing, regardless
  // of origin, but this is likely CloseEnough.

  const PORTAL_PICKER_REFERRER_SUBSTRING = `${getFullUrl('app')}/portal-recommend/l?slug=pricing`;
  const QA_TEST_REFERRER_SUBSTRING = '/public-pricing';
  const {
    referrer
  } = document;
  return Boolean(referrer.indexOf(WWW_REFERRER_SUBSTRING) > -1 || referrer.indexOf(BR_REFERRER_SUBSTRING) > -1 || referrer.indexOf(QA_TEST_REFERRER_SUBSTRING) > -1 || referrer.indexOf(PORTAL_PICKER_REFERRER_SUBSTRING) > -1);
};

const Application = ({
  children,
  location
}) => {
  const isBillingAdmin = useSelector(isBillingAdminSelector);
  const isAppAuth = useSelector(isAppAuthSelector);
  const activeCurrencyCode = useSelector(activeCurrencySelector);
  const upgradeSource = useQueryParamFromLocation(UPGRADE_SOURCE);
  const isRedirect = isHubSpotDotComAuthedUserRedirect();
  const {
    pathname
  } = location;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const wpParams = {
      wordpressPlugin: isWordPress
    };
    getUsageTracker().setProperties(Object.assign({
      isBillingAdmin,
      upgradeSource,
      inAppOrPublic: isAppAuth ? 'in-app' : 'public',
      activeCurrencyCode,
      isDotComAuthedRedirect: isAppAuth && isRedirect
    }, wpParams));

    if (isRedirect) {
      Metrics.counter('redirected-from-dotcom').increment();
    } //Set the properties for the "upgrade" app too


    tracker.setProperties(Object.assign({}, wpParams));
  }, []);
  const hasMisMatchedProductsAndPromotions = useAppSelector(state => {
    const hasPricingAndPurchasingSucceeded = hasPricingAndPurchasingSucceededSelector(state);
    if (!hasPricingAndPurchasingSucceeded) return false;
    return hasMisMatchedProductsAndPromotionsSelector(state);
  });

  if (hasMisMatchedProductsAndPromotions) {
    return /*#__PURE__*/_jsx(ErrorPage, {
      errorCause: MISMATCHED_RESPONSES
    });
  }

  if (isAppAuth) {
    if (isHubSpotDotComAuthedUserRedirect()) {
      /**
       * If we came from public hubspot.com/pricing render the dot com marketing nav.
       * This represents authenticated users who go to the website pricing pages
       * We want to preserve the dot com nav since otherwise it would lead to a weird
       * experience where they'd lose their nav and couldn't go back without using the
       * browser back button
       */
      return /*#__PURE__*/_jsx(PublicApplicationComponents, {
        isLoggedIn: true,
        pathname: location.pathname,
        children: /*#__PURE__*/_jsx("div", {
          className: "app-auth-marketing-nav-wrapped-page",
          children: children
        })
      });
    } else {
      return /*#__PURE__*/_jsx("div", {
        children: children
      });
    }
  } else {
    return /*#__PURE__*/_jsx(PublicApplicationComponents, {
      isLoggedIn: false,
      pathname: location.pathname,
      children: children
    });
  }
};

export default withRouter(Application);